import { makeApiRequest } from './api';

/** Mirrors the API's EBusinessPermission values. */
export type TBusinessPermission =
  | 'business:view'
  | 'business:edit'
  | 'business:delete'
  | 'team:view'
  | 'team:invite'
  | 'team:manage_roles'
  | 'team:remove'
  | 'campaign:view'
  | 'campaign:create'
  | 'campaign:edit'
  | 'campaign:delete'
  | 'campaign:launch'
  | 'analytics:view'
  | 'analytics:export'
  | 'billing:view'
  | 'billing:manage'
  | (string & {});

export interface IMyBusinessPermissions {
  businessId: string;
  role: string | null;
  permissions: TBusinessPermission[];
}

/** The signed-in user's role and permissions in a business. */
export const getMyBusinessPermissionsService = async (
  businessId: string,
  token: string
): Promise<IMyBusinessPermissions | null> => {
  const response = await makeApiRequest<{ data?: unknown }>(
    `/businesses/${businessId}/users/me/permissions`,
    { method: 'GET', token }
  );
  const payload = (response as { data?: unknown } | null)?.data ?? response;
  const inner =
    payload && typeof payload === 'object' && 'data' in payload
      ? (payload as { data: unknown }).data
      : payload;
  return inner && typeof inner === 'object'
    ? (inner as IMyBusinessPermissions)
    : null;
};
